export const cookieTranslations = {
  buttonAccept: "Alle cookies aanvaarden",
  buttonReject: "Optionele cookies weigeren",
  buttonSetup: "Voorkeuren instellen",
  buttonBack: "Terug",
  textCookieTypes: "Soorten cookies",
  textCookiePolicy: "Lees onze cookieverklaring",
  buttonSaveSettings: "Voorkeuren opslaan",
  tableHeaderCookie: "Cookie",
  tableHeaderType: "Type",
  tableHeaderDuration: "Duur",
  tableHeaderDescription: "Omschrijving",
  textAlwaysOn: "Altijd ingeschakeld",
  textOn: "Ingeschakeld",
  textOff: "Uitgeschakeld",
}

export const contentBlockerTranslations = {
  buttonOpenCookieSettings: "Open cookie-instellingen",
}
